import * as React from 'react';
import clsx from 'clsx';

import { formatStartTime } from 'lib/util/formatStartTime';
import { LinkableTextArea } from 'components/LinkableTextArea/LinkableTextArea';
import { ProductShape } from 'lib/util/productShape';
import { applyRelativeTimeOffset } from 'lib/util/applyRelativeTimeOffset';

interface Props {
  product: ProductShape;
}

export const ScheduleTab = ({ product }: Props) => {
  const [selectedStartTime, setSelectedStartTime] = React.useState<string>(
    product.startTimes.length > 0 ? product.startTimes[0].hhMm : ''
  );
  const handleStartTimeChange = (event: React.ChangeEvent<HTMLSelectElement>) =>
    setSelectedStartTime(event.target.value);

  return (
    <div className="c-schedule">
      <label className="c-schedule__select">
        <select name="startTime" value={selectedStartTime} onChange={handleStartTimeChange}>
          {product.startTimes.map((startTime) => (
            <option key={startTime.hhMm} value={startTime.hhMm}>
              {formatStartTime(startTime)}
            </option>
          ))}
        </select>
      </label>
      <ul className="c-schedule__list">
        {product.schedule.map((event) => {
          const eventStartTime = event.startTimeRelative
            ? applyRelativeTimeOffset(selectedStartTime, event.startTimeRelative)
            : '';
          const eventEndTime = event.endTimeRelative
            ? applyRelativeTimeOffset(selectedStartTime, event.endTimeRelative)
            : '';

          const timeDescription = eventEndTime
            ? `${eventStartTime} - ${eventEndTime}`
            : eventStartTime;

          return (
            <li key={event.name} className="c-schedule__list__item">
              <p className="c-schedule__list__item__time">{timeDescription}</p>
              <div className="c-schedule__list__item__body">
                <p className="c-schedule__list__item__body__title">{event.name}</p>
                <p className={clsx('c-schedule__list__item__body__text', 'newline')}>
                  <LinkableTextArea>{event.description}</LinkableTextArea>
                </p>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
